import React, { useCallback } from "react";
import { Button } from "antd";
import "./FooterButtonGroup.css";
import { BUTTON_CONFIGS } from "../../../util/Constants";
import PropTypes from "prop-types";
import { ButtonTypes } from "../../../util/ButtonTypes";

const FooterButtonGroup = ({ onReset, onNext, onSave,activeTabKey,tabList }) => {
  const handleButtonClick = useCallback(
    (buttonType) => {
      if (buttonType === ButtonTypes.RESET) {
        onReset();
      } else if (buttonType === ButtonTypes.NEXT) {
        onNext();
      } else if (buttonType === ButtonTypes.SAVE) {
        onSave();
      } else {
        console.warn(`Unknown button type: ${buttonType}`);
      }
    },
    [onReset, onNext, onSave]
  );
  const visibleButtons = BUTTON_CONFIGS.filter((button) => {
    if (activeTabKey === "preSurvey" && Object.keys(tabList).length<2 ) {
        
      return button.text !== ButtonTypes.RESET && button.text !== ButtonTypes.NEXT; 
    }else if(activeTabKey === "preSurvey"){
      return button.text !== ButtonTypes.RESET;
    }else if(activeTabKey==="cdpDetails" && Object.keys(tabList).length<3){
        return button.text !== ButtonTypes.NEXT
    }
   
    
    return true; 
  });

  return (
    <div className="footer-buttons-container">
      {visibleButtons.map((button) => (
        <Button
          key={button.id}
          className={`footer-button ${button.className} ${ activeTabKey === "reporting" ? "hidden" : ""}`}
          onClick={() => handleButtonClick(button.text)}
        >
          {button.text}
        </Button>
      ))}
    </div>
  );
};

FooterButtonGroup.propTypes = {
  onReset: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  activeTabKey: PropTypes.string.isRequired
};

export default FooterButtonGroup;
